var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.588,
    height: 80.264,
    viewBox: "0 0 74.588 80.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69091",
    "data-name": "Path 69091",
    d: "M8.971,60.282a4.517,4.517,0,0,0,.3-1.6,4.574,4.574,0,0,0-.072-.788l10.044-5.545a4.525,4.525,0,0,0,3.067,1.2,4.581,4.581,0,0,0,.568-.039L33.412,74.393ZM50.855,41.472,65.479,58.008a4.515,4.515,0,0,0-.369,1.793,4.605,4.605,0,0,0,.044.6L38.879,75.569l10.134-33.93a4.495,4.495,0,0,0,1.842-.167M25.1,52.578a4.525,4.525,0,0,0,1.564-4.857L45.9,39.853a4.538,4.538,0,0,0,.872.88L36.49,75.155ZM25,45.344l9.915-17.3a4.519,4.519,0,0,0,2.618,0l7.8,7.345a4.55,4.55,0,0,0-.344,1.737,4.625,4.625,0,0,0,.027.493L25.369,45.65A4.7,4.7,0,0,0,25,45.344M5.616,54.225V25.295l.051-.012L18.6,46.371a4.524,4.524,0,0,0-.647,3.938L8.161,55.716a4.536,4.536,0,0,0-2.545-1.491M52.907,40.157a4.511,4.511,0,0,0,.871-4.63L66.94,24.475a4.523,4.523,0,0,0,1.769,1.031v29.85a4.515,4.515,0,0,0-1.7.753ZM39.62,26.706a4.52,4.52,0,0,0,1.129-2.567l24.367-1.273L52.363,33.575a4.527,4.527,0,0,0-5.547-.092ZM7.761,24.093a4.527,4.527,0,0,0,1.01-1.546l23.012,2.092a4.524,4.524,0,0,0,1.093,2.114L22.723,44.475c-.139-.012-.278-.022-.419-.022a4.522,4.522,0,0,0-1.822.383Zm1.265-3.938c-.009-.063-.016-.127-.029-.188L35.747,4.523l-.91,14.841a4.549,4.549,0,0,0-2.914,2.873Zm28.226-.89.92-14.977L65.618,20.134c-.022.1-.041.2-.057.3L40.333,21.751a4.544,4.544,0,0,0-3.081-2.486M37.163,0,7.277,17.256a4.542,4.542,0,1,0-4.869,7.637V54.775a4.541,4.541,0,0,0,4.379,7.951L37.163,80.264l29.51-17.038a4.542,4.542,0,1,0,5.245-7.362V25.3a4.542,4.542,0,1,0-4.511-7.834Z",
    fill: "#61cafa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 74.588,
    height: 80.264,
    transform: "translate(0 0)",
    fill: "#61cafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLink);
export default __webpack_public_path__ + "static/media/ai_link.34779174fded21eb9c71dcfd7872a42b.svg";
export { ForwardRef as ReactComponent };